import React, { useState, useEffect } from "react";

import moment from "moment";
import { Tabs, Tab } from "react-bootstrap";

import NurseryList from "../Component/NurseryList";

import * as Constant from "../../../Constant.js";

import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import axios from "@app/lib/axios";
import * as commonData from "@app/lib/common_data";

import NurseryFormTable from "../Component/NurseryFormTable";

import ContractView from "../Contract/List/View.js";
import ContractControlBtn from "../Component/ContractControlBtn.js";

const CONTRACT_TABLE_ID = "contractTable";

const View = ({ id, listPage, type }) => {
    const [data, setData] = useState(null);
    const [loadingData, setLoadingData] = useState(true);
    const [bizApp, setBizApp] = useState([]);
    const [contractList, setContractList] = useState(null);
    const [director, setDirector] = useState(null);
    const [serviceAppList, setServiceAppList] = useState(null);
    const [appAuthTypeList, setAppAuthTypeList] = useState(null);
    const [branches, setBranches] = useState(null);

    useEffect(() => {
        if (!serviceAppList && !appAuthTypeList) {
            getBaseInfo();
        }
        return () => {};
    }, [id, type]);

    useEffect(() => {
        if (serviceAppList && appAuthTypeList) {
            getData(id);
            getContractList(id);
        }
    }, [serviceAppList, appAuthTypeList]);

    const getBaseInfo = () => {
        commonData.getAppAuthTypeList(axios, (err, typeList) => {
            if (!err) {
                setAppAuthTypeList(typeList);
                commonData.getServiceAppList(axios, (err, appList) => {
                    if (!err) {
                        setServiceAppList(appList);
                    }
                });
            } else {
            }
        });
    };

    const getData = (id) => {
        setLoadingData(true);
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/nursery/info/0/${id}`,
        })
            .then((res) => {
                const _data = res.data.nursery;
                setData(_data);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    };

    const getContractList = (id) => {
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/contract/list/0/${id}`,
        })
            .then((res) => {
                const list = res.data && res.data.contract ? res.data.contract : [];
                const bizApp = {};
                res.data.bizApp.forEach((app) => {
                    bizApp[app] = { id: app, hasPreContractedBranch: false };
                    bizApp[app].info = serviceAppList.find((sa) => sa.key == app);
                    bizApp[app].authTypeList = appAuthTypeList[app];
                });
                // 기존 계약 승인 정보 보관
                list.forEach((c) => {
                    if (c.app_auth) {
                        const auth = c.app_auth;
                        serviceAppList.forEach((a) => {
                            if(a.contractUseTas && bizApp[a.key]) {
                                if(auth[a.key] && auth[a.key].approval) {
                                    auth[a.key].approval_org = auth[a.key].approval;
                                    auth[a.key].authType_org = auth[a.key].authType;
                                    auth[a.key].authTypeName_org = auth[a.key].authTypeName;
                                }
                            }
                        });
                        // 결합 상품 정보 설정
                        if(c.unionId_org) {
                            c.unionSelected = appAuthTypeList.all.find((at) => at.id == c.unionId);
                        }
                    }
                });
                list.sort((a, b) => (a.is555 == b.is555 ? (a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age) : a.is555 ? 1 : -1));
                setDirector(res.data.director);
                setBizApp(bizApp);
                setBranches(res.data.branches);
                setContractList(list);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const submitData = () => {
        const nursery = window.getNurseryFormData();
        if (!nursery.name || !nursery.type || !nursery.sub_type || !nursery.ceo || !nursery.director || !nursery.sido || !nursery.sigungu || !nursery.addr || !nursery.tel) {
            alert("입력이 누락된 항목이 있습니다.\n모든 항목에 정보를 입력하신 후 \n저장 버튼을 눌러주세요.");
            return;
        }
        nursery.adMemo = document.getElementById("admin-memo").value;

        axios({
            method: "put",
            url: `${Constant.API_DOMAIN}/api/nursery/info/`,
            data: nursery,
        })
            .then((res) => {
                if (res.data.nurseryId == nursery.id) {
                    alert("수정 되었습니다");
                } else {
                    console.error("알 수 없는 오류가 발생하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    };

    if (!data) {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-ecommerce"></div>
            </div>
        );
    }

    const cancelHandler = () => {
        if (window.confirm("원 수정을 취소하시겠습니까?")) {
            if (listPage) listPage();
            else history.back();
        }
    };

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                            <div className="page-header">
                                <h2 className="pageheader-title">{data.name}</h2>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-right">
                            <button className="btn btn-primary btn-rounded" onClick={cancelHandler}>
                                목록
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content pb-5">
                    <div className="row">
                        <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                            <NurseryFormTable nursery={data} />
                            <div className="row">
                                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                                    <button className="btn btn-brand btn-rounded mr-2" onClick={submitData}>
                                        저장
                                    </button>
                                    <button className="btn btn-default btn-rounded mr-2" onClick={cancelHandler}>
                                        취소
                                    </button>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 text-right mt-1">{data.update_date} updated</div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                            <NurseryBranchInfoTab data={data} memoList={data.memo} reportList={data.report} activeTabKey={type} />
                        </div>
                    </div>

                    <div className="div-table-contract div-table-contract-view">
                        <div className="row mt-5">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                {serviceAppList && appAuthTypeList && <ContractView.ContractViewMaster
                                    tableId={CONTRACT_TABLE_ID}
                                    branches={branches}
                                    bizApp={bizApp}
                                    serviceAppList={serviceAppList}
                                    appAuthTypeList={appAuthTypeList}
                                    list={contractList}
                                    director={director}
                                    nurseryUniqId={data.id || ""}
                                    nurseryUniqName={data.name || ""}
                                    changeList={(newList) => {
                                        setContractList(newList);
                                    }}
                                />}
                            </div>
                        </div>
                    </div>
                    {serviceAppList && appAuthTypeList && <ContractControlBtn
                        branchId={0}
                        nurseryId={data.id}
                        nurseryName={data.name}
                        directorName={data.director}
                        address={data.address}
                        tableId={CONTRACT_TABLE_ID}
                        list={contractList}
                        director={director}
                        bizApp={bizApp}
                        serviceAppList={serviceAppList}
                        appAuthTypeList={appAuthTypeList}
                    />}
                </div>
            </div>
        </div>
    );
};

const ReportForm = ({ report }) => {
    const [data, setData] = useState(report);
    const [doSubmit, isDoSubmit] = useState(false);

    const changeStatus = (e) => {
        const { value } = e.target;
        let act = "대기";
        switch (value) {
            case "W":
                act = "대기";
                break;
            case "R":
                act = "반려";
                break;
            case "A":
                act = "수정완료";
                break;
            default:
                act = "대기";
                break;
        }

        if (window.confirm(`해당 요청건에 대해 ${act} 처리 하시겠습니까?`)) {
            submitChangeStatus(data.id, value);
        }
    };

    useEffect(() => {
        setData(report);
    }, [report]);

    const submitChangeStatus = (id, status) => {
        isDoSubmit(true);
        axios({
            method: "put",
            url: `${Constant.API_DOMAIN}/api/nursery/report/${id}/${status}`,
        })
            .then((res) => {
                const _data = { ...data };
                _data.status = status;
                _data.update_date = moment().format("YYYY-MM-DD HH:MM");
                setData(_data);
                isDoSubmit(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                isDoSubmit(false);
            });
    };

    return (
        <table className="table table-bordered mt-2">
            <colgroup>
                <col style={{ width: "100px" }} />
                <col />
                <col style={{ width: "140px" }} />
            </colgroup>
            <tr>
                <th className="bg-primary">수정 요청</th>
                <td>{data.branch_name}</td>
                <td>{data.create_date}</td>
            </tr>
            <tr>
                <th className="bg-primary">처리 결과</th>
                <td>
                    <label htmlFor={`report_accept_${data.id}`} className="custom-control custom-radio custom-control-inline border-secondary border-3">
                        <input
                            id={`report_accept_${data.id}`}
                            type="radio"
                            className="custom-control-input"
                            name={`report_status_${data.id}`}
                            value="A"
                            checked={data.status === "A"}
                            onChange={changeStatus}
                            disabled={doSubmit}
                        />
                        <span className="custom-control-label">수정 완료</span>
                    </label>
                    <label htmlFor={`report_reject_${data.id}`} className="custom-control custom-radio custom-control-inline">
                        <input
                            id={`report_reject_${data.id}`}
                            type="radio"
                            className="custom-control-input"
                            name={`report_status_${data.id}`}
                            value="R"
                            checked={data.status === "R"}
                            onChange={changeStatus}
                            disabled={doSubmit}
                        />
                        <span className="custom-control-label">반려</span>
                    </label>
                    <label htmlFor={`report_waiting_${data.id}`} className="custom-control custom-radio custom-control-inline">
                        <input
                            id={`report_waiting_${data.id}`}
                            type="radio"
                            className="custom-control-input"
                            name={`report_status_${data.id}`}
                            value="W"
                            checked={data.status === "W"}
                            onChange={changeStatus}
                            disabled={doSubmit}
                        />
                        <span className="custom-control-label">대기</span>
                    </label>
                </td>
                <td>{data.status !== "W" && data.update_date}</td>
            </tr>
            <tr>
                <td colSpan="3" className="p-0">
                    <textarea value={data.description} className="form-control" disabled={1} row={4} />
                </td>
            </tr>
        </table>
    );
};

const NurseryMemo = ({ memo }) => {
    let textMemo;

    if (!memo || !memo.memo) {
        textMemo = "";
    } else {
        textMemo = memo.memo;
    }

    return (
        <table className="table table-border mt-2">
            <colgroup>
                <col style={{ width: "110px" }} />
                <col />
            </colgroup>
            <tbody>
                <tr>
                    <th className="bg-primary-light text-dark">관리 지사</th>
                    <td>{memo.branch_name}</td>
                </tr>
                <tr>
                    <th className="bg-primary-light text-dark">원장 휴대전화</th>
                    <td>{memo.director_mobile}</td>
                </tr>
                <tr>
                    <th className="bg-primary-light text-dark">담당교사정보</th>
                    <td>
                        {memo.charger} {memo.charger_mobile}
                    </td>
                </tr>
                <tr>
                    <th className="bg-primary-light text-dark">메모</th>
                    <td className="p-0">
                        <textarea className="form-control" value={textMemo} disabled />
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

const AdminNurseryMemo = ({ memo }) => {
    return (
        <table className="table table-border mt-2">
            <colgroup>
                <col style={{ width: "110px" }} />
                <col />
            </colgroup>
            <tbody>
                <tr>
                    <th className="bg-primary-light text-dark">메모</th>
                    <td className="p-0">
                        <textarea className="form-control mb-1 p-1" id="admin-memo" name="admin-memo" rows={7}>{memo}</textarea>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

const NurseryBranchInfoTab = ({ data, memoList, reportList, activeTabKey }) => {
    const [activeTab, setActiveTab] = useState(activeTabKey || "memo");

    useEffect(() => {
        if (activeTabKey) setActiveTab(activeTabKey);
        return () => {};
    }, [memoList, reportList, activeTabKey]);

    return (
        <div className="card" style={{ height: "560px", maxHeight: "560px", overflow: "auto" }}>
            <div className="card-body p-2">
                <Tabs
                    activeKey={activeTab}
                    onSelect={(k) => {
                        setActiveTab(k);
                    }}
                >
                    <Tab eventKey="memo" title="원 관리 정보" className="pt-2">
                        {memoList &&
                            memoList.map((m, idx) => {
                                return <NurseryMemo memo={m} key={`tab-nursery-memo-${idx}`} />;
                            })}
                    </Tab>
                    <Tab eventKey="report" title="원 정보 수정 요청" className="pt-2">
                        {reportList &&
                            reportList.map((r, idx) => {
                                return <ReportForm report={r} key={`tab-nursery-report-${idx}`} />;
                            })}
                    </Tab>
                    <Tab eventKey="ad-memo" title="원 본사 메모" className="pt-2">
                        {data && <AdminNurseryMemo memo={data.admin_memo} key={`tab-nursery-admin-memo`} />}
                    </Tab>
                </Tabs>
            </div>
        </div>
    );
};

export default View;
